/* eslint-disable no-unsafe-optional-chaining */
import React from 'react'
import { Button } from '@fs/zion-ui'
import { Trans } from 'react-i18next'
import isEmpty from 'lodash.isempty'

export const validate = (values, t) => {
  const errors = {}
  if (isEmpty(values.eventType)) {
    errors.eventType = {
      type: 'required',
      message: t('edit-events.fields.event-type-required', 'Event Type is required'),
    }
  }

  return {
    values,
    errors,
  }
}

export const generateFaqList = (t, useSharedEvent, openOverlay) => {
  const faqs = [
    {
      key: '1',
      question: t('edit-event.faq-question-1', 'What is an Event?'),
      answer: t(
        'edit-event.faq-answer-1',
        'An event is an important occasion that happened within a document. There can be many events in one document.'
      ),
    },
    {
      key: '2',
      question: t('edit-event.faq-question-2', 'What do I include in an event?'),
      answer: t(
        'edit-event.faq-answer-2',
        'Mainly an Event Type, Date, and Place. Though there are more options within the "Add More Information" buttons in each section.'
      ),
    },
    {
      key: '3',
      question: t('edit-event.faq-question-3', 'What is an Event Type?'),
      answer: t(
        'edit-event.faq-answer-3',
        'The Event Type states the kind of event this is. For example, if this is an Christening event, the event type would be "Christening".'
      ),
    },
  ]

  if (useSharedEvent) {
    faqs.push(
      {
        key: '4',
        question: t('edit-event.faq-question-4', 'What if this event belongs to others?'),
        answer: (
          <Trans i18nKey="edit-event.faq-answer-4">
            Select <Button onClick={() => openOverlay('sharedEvent')}>Names Linked to Event</Button>
          </Trans>
        ),
      },
      {
        key: '5',
        question: t('edit-event.faq-question-5', 'What if I want to link to an existing event?'),
        answer: (
          <Trans i18nKey="edit-event.faq-answer-5">
            Select <strong>Cancel.</strong> Then, next to New Event, select <strong>+</strong> and{' '}
            <strong>Link to an existing event.</strong>
          </Trans>
        ),
      }
    )
  }

  return faqs
}

export const buildEventFieldHighlights = (getValues, getHighlights) => {
  const filterHighlights = (highlights, fieldIds) =>
    highlights.filter((highlight) => fieldIds.includes(highlight.fieldId))

  const { mainEditHighlights, splitScreenEditHighlights } = getHighlights()
  const { dateFields, placeFields, otherFields, relationshipPerson, eventTypeField: evtField } = getValues()

  const nameHighlights = relationshipPerson
    ? mainEditHighlights
        .filter(
          (highlight) =>
            highlight?.personIds?.includes(relationshipPerson?.key) &&
            ['NAME_GN', 'NAME_SURN', 'NAME_SUF'].includes(highlight?.fieldType)
        )
        .map((highlight) => highlight.fieldId)
    : []

  // We need to know all the field ids to filter the highlights
  const fieldIds = [
    evtField?.id,
    ...nameHighlights,
    ...dateFields?.map((field) => field.id),
    ...placeFields?.map((field) => field.id),
    ...otherFields?.map((field) => field.id),
  ].filter(Boolean)

  return [...filterHighlights(mainEditHighlights, fieldIds), ...filterHighlights(splitScreenEditHighlights, fieldIds)]
}
